/*
 * EcomHub Bundle
 * Uses the theme's native cart drawer renderer.
 */

(function () {
  'use strict';

  function cartRoot() {
    var root =
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root;

    return (root || '/').replace(/\/?$/, '/');
  }

  function formatMoney(cents, format) {
    var template = format || '${{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var match = template.match(placeholder);
    var token = match ? match[1] : 'amount';

    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }

    cents = Number(cents) || 0;

    function number(precision, thousands, decimal) {
      var parts = (cents / 100).toFixed(precision).split('.');

      return parts[0].replace(
        /(\d)(?=(\d{3})+(?!\d))/g,
        '$1' + thousands
      ) + (parts[1] ? decimal + parts[1] : '');
    }

    var value;

    switch (token) {
      case 'amount_no_decimals':
        value = number(0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        value = number(2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = number(0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = number(2, "'", '.');
        break;
      case 'amount_with_space_separator':
        value = number(2, ' ', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = number(0, ' ', '.');
        break;
      default:
        value = number(2, ',', '.');
    }

    return template.replace(placeholder, value);
  }

  function getSectionIds(drawer) {
    var definitions = drawer.getSectionsToRender();

    return definitions.map(function (section) {
      return section.section || section.id;
    }).filter(function (id, index, ids) {
      return id && ids.indexOf(id) === index;
    });
  }

  function hasSections(sections, ids) {
    return Boolean(sections) && ids.every(function (id) {
      return typeof sections[id] === 'string' &&
        sections[id].trim().length > 0;
    });
  }

  async function refreshSections(ids) {
    var url = new URL(
      window.location.pathname,
      window.location.origin
    );

    url.searchParams.set('sections', ids.join(','));

    var response = await fetch(url.toString(), {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('Could not refresh the cart sections.');
    }

    var sections = await response.json();

    if (!hasSections(sections, ids)) {
      throw new Error('Shopify returned incomplete cart sections.');
    }

    return sections;
  }

  async function updateDrawer(drawer, result, ids, button) {
    var sections = result.sections;

    /*
     * Validate section strings only.
     * The native renderer decides which selectors to extract.
     */
    if (!hasSections(sections, ids)) {
      sections = await refreshSections(ids);
    }

    if (typeof drawer.setActiveElement === 'function') {
      drawer.setActiveElement(button);
    }

    // Required when adding to a previously empty Dawn-style drawer.
    drawer.classList.remove('is-empty');

    var firstItem = result.items && result.items[0];

    var renderedState = Object.assign({}, result, {
      id: result.id || (firstItem && firstItem.id),
      sections: sections
    });

    /*
     * Let the theme update its drawer, header icon, timer,
     * event listeners, focus handling, and opening behavior.
     */
    await drawer.renderContents(renderedState);

    // Native renderers may schedule their opening asynchronously.
    await new Promise(function (resolve) {
      window.requestAnimationFrame(resolve);
    });

    if (!drawer.classList.contains('active')) {
      drawer.open();
    }
  }

  function initBundle(root) {
    if (root.__ehpBnd) {
      return;
    }

    root.__ehpBnd = true;

    var dynamic = root.getAttribute('data-dynamic') === '1';
    var money =
      root.getAttribute('data-money-format') || '${{amount}}';

    var sectionPercent =
      parseFloat(root.getAttribute('data-section-pct')) || 0;

    var sectionFixed =
      parseInt(root.getAttribute('data-section-fixed'), 10) || 0;

    var items = Array.prototype.slice.call(
      root.querySelectorAll('[data-bnd-item]')
    );

    var finalElement = root.querySelector('[data-bnd-final]');
    var totalElement = root.querySelector('.ehp-bnd__total-val');
    var button = root.querySelector('[data-bnd-atc]');
    var errorElement = root.querySelector('[data-bnd-err]');
    var loading = false;

    function state(item) {
      var checkbox = item.querySelector('[data-bnd-check]');
      var select = item.querySelector('[data-bnd-variant]');

      var option =
        select && select.selectedIndex >= 0
          ? select.options[select.selectedIndex]
          : null;

      var price = parseInt(
        option
          ? option.getAttribute('data-price')
          : item.getAttribute('data-base'),
        10
      ) || 0;

      var variantId = option
        ? option.value
        : item.getAttribute('data-variant-id');

      var planValue = option
        ? option.getAttribute('data-selling-plan')
        : null;

      if (planValue == null) {
        planValue = item.getAttribute('data-selling-plan');
      }

      var sellingPlan = parseInt(planValue, 10);

      var percent =
        parseFloat(item.getAttribute('data-prod-pct')) || 0;

      var fixed =
        parseInt(item.getAttribute('data-prod-fixed'), 10) || 0;

      var discounted = percent
        ? Math.round(price * (100 - percent) / 100)
        : price;

      return {
        checked: checkbox ? checkbox.checked : true,
        vid: variantId,
        base: price,
        disc: Math.max(0, discounted - fixed),
        sellingPlan:
          Number.isSafeInteger(sellingPlan) && sellingPlan > 0
            ? sellingPlan
            : null
      };
    }

    function recompute() {
      var originalTotal = 0;
      var discountedTotal = 0;
      var any = false;

      items.forEach(function (item) {
        var product = state(item);

        item.classList.toggle('is-off', !product.checked);

        if (dynamic) {
          var linePrice = item.querySelector('[data-bnd-lineprice]');

          if (linePrice) {
            linePrice.textContent = '';

            if (product.disc < product.base) {
              var was = document.createElement('s');
              was.className = 'ehp-bnd__was';
              was.textContent = formatMoney(product.base, money);
              linePrice.appendChild(was);
            }

            var now = document.createElement('span');
            now.className = 'ehp-bnd__now';
            now.textContent = formatMoney(product.disc, money);
            linePrice.appendChild(now);
          }
        }

        if (product.checked && product.vid) {
          any = true;
          originalTotal += product.base;
          discountedTotal += product.disc;
        }
      });

      if (dynamic) {
        var total = sectionPercent
          ? Math.round(
              discountedTotal * (100 - sectionPercent) / 100
            )
          : discountedTotal;

        total = Math.max(0, total - sectionFixed);

        if (finalElement) {
          finalElement.textContent = formatMoney(total, money);
        }

        var compare = root.querySelector('[data-bnd-compare]');

        if (total < originalTotal) {
          if (
            !compare &&
            totalElement &&
            finalElement &&
            finalElement.parentNode === totalElement
          ) {
            compare = document.createElement('s');
            compare.className = 'ehp-bnd__was';
            compare.setAttribute('data-bnd-compare', '');
            totalElement.insertBefore(compare, finalElement);
          }

          if (compare) {
            compare.textContent = formatMoney(originalTotal, money);
          }
        } else if (compare) {
          compare.remove();
        }
      }

      if (button) {
        button.disabled = loading || !any;
      }
    }

    function showError(message) {
      if (errorElement) {
        errorElement.textContent = message;
        errorElement.hidden = false;
        errorElement.setAttribute('role', 'alert');
      } else {
        window.alert(message);
      }
    }

    root.addEventListener('change', function (event) {
      if (
        event.target.matches('[data-bnd-check]') ||
        event.target.matches('[data-bnd-variant]')
      ) {
        recompute();
      }
    });

    recompute();

    if (!button) {
      return;
    }

    button.addEventListener('click', async function (event) {
      event.preventDefault();

      if (loading) {
        return;
      }

      var selected = items.map(state).filter(function (product) {
        return product.checked && product.vid;
      });

      if (!selected.length) {
        showError('Select at least one product.');
        return;
      }

      var cartItems = selected.map(function (product) {
        var item = {
          id: Number(product.vid),
          quantity: 1
        };

        if (product.sellingPlan) {
          item.selling_plan = product.sellingPlan;
        }

        return item;
      });

      if (cartItems.some(function (item) {
        return !Number.isSafeInteger(item.id) || item.id <= 0;
      })) {
        showError('Please select a valid product variant.');
        return;
      }

      loading = true;
      button.disabled = true;
      button.classList.add('is-loading');
      button.setAttribute('aria-busy', 'true');

      if (errorElement) {
        errorElement.hidden = true;
      }

      var added = false;
      var requestStarted = false;

      try {
        var drawer = document.querySelector('cart-drawer');

        if (
          !drawer ||
          typeof drawer.renderContents !== 'function' ||
          typeof drawer.getSectionsToRender !== 'function' ||
          typeof drawer.open !== 'function'
        ) {
          throw new Error(
            'The native cart drawer is unavailable. Please reload and try again.'
          );
        }

        var ids = getSectionIds(drawer);

        if (!ids.length || ids.length > 5) {
          throw new Error('The drawer returned invalid cart sections.');
        }

        requestStarted = true;

        var response = await fetch(cartRoot() + 'cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items: cartItems,
            sections: ids,
            sections_url: window.location.pathname
          })
        });

        if (!response.ok) {
          requestStarted = false;

          var failure = await response.json().catch(function () {
            return {};
          });

          throw new Error(
            failure.description ||
            failure.message ||
            'Shopify could not add the selected products.'
          );
        }

        added = true;

        var result = await response.json().catch(function () {
          return {};
        });

        await updateDrawer(drawer, result, ids, button);
      } catch (error) {
        console.error('EcomHub Bundle Error:', error);

        if (added) {
          showError(
            'The bundle was added, but the drawer update failed. ' +
            'Refresh to check your cart before adding again. ' +
            error.message
          );
        } else if (requestStarted) {
          showError(
            'Could not confirm the cart update. Refresh to check your cart ' +
            'before trying again.'
          );
        } else {
          showError(error.message || 'Could not add the bundle.');
        }
      } finally {
        loading = false;
        button.classList.remove('is-loading');
        button.removeAttribute('aria-busy');
        recompute();
      }
    });
  }

  function boot(scope) {
    var container = scope || document;

    if (
      container.matches &&
      container.matches('[data-ehp-bundle]')
    ) {
      initBundle(container);
    }

    container.querySelectorAll('[data-ehp-bundle]').forEach(initBundle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();